import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=2e09667c&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./layout.vue?vue&type=style&index=1&id=2e09667c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e09667c",
  null
  
)

export default component.exports